module.exports = __webpack_public_path__ + "static/media/adithya.9a98ad14.jpg";